import React from 'react';
import { Tooltip } from '@rcg/ui-react';
import InfoIcon from '@material-ui/icons/Info';
import useStyles from './useStyles';

const InfoTooltip = ({ title, description, tooltipOffsetLeft, dataTestId = null }) => {
  const classes = useStyles();
  const info = () => {
    return (
      <div className={classes.infoTooltip}>
        {title && <div className={classes.infoTooltipTitle}>{title}</div>}
        <div className={classes.infoTooltipDescription}>{description}</div>
      </div>
    );
  };
  const handleClickTooltip = () => {
    const container = document.querySelector('.main-container');
    container.scrollTo(0, document.querySelector('.main-container').scrollTop + 1);
    container.scrollTo(0, document.querySelector('.main-container').scrollTop - 1);
  };

  return (
    <span data-testid={dataTestId} className={classes.infoTooltipIcon}>
      <Tooltip
        toolTipExtraClasses="diego"
        element={<InfoIcon className={classes.infoIcon} />}
        content={info()}
        tooltipProps={{
          PopperProps: {
            modifiers: {
              offset: {
                enabled: true,
                offset: `${tooltipOffsetLeft}, 0`,
              },
            },
          },
        }}
        onClickTooltipHandler={handleClickTooltip}
      />
    </span>
  );
};

export default InfoTooltip;
